import { Link, useParams } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import StudentModals from "../studentModals";
import StudentSidebar from "./studentSidebar";
import StudentBreadcrumb from "./studentBreadcrumb";
import { useGetStudentByIdQuery } from "../api/studentApi";
import { API_CONFIG } from "../../../../core/config";

const StudentDetails = () => {
  const routes = all_routes;
  const { id } = useParams<{ id: string }>();
  const {
    data: studentResponse,
    isLoading,
    error,
  } = useGetStudentByIdQuery({ id: id || "" });
  const student = studentResponse?.data?.student;
  const studentStatus = student?.status;

  if (isLoading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <StudentBreadcrumb studentId={id} />
          </div>
          <div className="row">
            <StudentSidebar />
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                    <li>
                      <Link
                        to={`${routes.studentDetail.replace(":id", id || "")}`}
                        className="nav-link active"
                      >
                        <i className="ti ti-school me-2" />
                        Student Details
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentAttendanceDetail.replace(
                          ":id",
                          id || ""
                        )}`}
                        className="nav-link"
                      >
                        <i className="ti ti-calendar-due me-2" />
                        Attendance
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentFees.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-report-money me-2" />
                        Fees
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentResult.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-bookmark-edit me-2" />
                        Results
                      </Link>
                    </li>
                  </ul>

                  <div className="card">
                    <div className="card-body p-0 py-3">
                      <div className="text-center">
                        Loading student details...
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return <div>Error loading student data</div>;
  }

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            {/* Page Header */}
            <StudentBreadcrumb studentId={id} studentStatus={studentStatus} />
            {/* /Page Header */}
          </div>
          <div className="row">
            {/* Student Information */}
            <StudentSidebar />
            {/* /Student Information */}
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  {/* List */}
                  <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                    <li>
                      <Link
                        to={`${routes.studentDetail.replace(":id", id || "")}`}
                        className="nav-link active"
                      >
                        <i className="ti ti-school me-2" />
                        Student Details
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentAttendanceDetail.replace(
                          ":id",
                          id || ""
                        )}`}
                        className="nav-link"
                      >
                        <i className="ti ti-calendar-due me-2" />
                        Attendance
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentFees.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-report-money me-2" />
                        Fees
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentResult.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-bookmark-edit me-2" />
                        Results
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* Address */}
                <div className="col-xxl-12 d-flex">
                  <div className="card flex-fill w-100">
                    <div className="card-header">
                      <h5>Address</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="d-flex align-items-center mb-3">
                            <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                              <i className="ti ti-map-pin-up" />
                            </span>
                            <div>
                              <p className="text-dark fw-medium mb-1">
                                Current Address
                              </p>
                              <p>
                                {student?.address?.street},{" "}
                                {student?.address?.city},
                                <br />
                                {student?.address?.state} {" "}
                                {student?.address?.pincode ? "-" : ""}{" "}
                                {student?.address?.pincode || ""}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-center mb-3">
                            <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                              <i className="ti ti-map-pins" />
                            </span>
                            <div>
                              <p className="text-dark fw-medium mb-1">
                                Permanent Address
                              </p>
                              <p>
                                {student?.address?.street},{" "}
                                {student?.address?.city},
                                <br />
                                {student?.address?.state} {" "}
                                {student?.address?.pincode ? "-" : ""}{" "}
                                {student?.address?.pincode || ""}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Address */}
                {/* School Details */}
                <div className="col-xxl-12">
                  <div className="card">
                    <div className="card-header">
                      <h5>School Details</h5>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">
                              School Name
                            </p>
                            <p>{student?.profile?.institution_name || "N/A"}</p>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Class</p>
                            <p>{student?.profile?.class || "N/A"}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Previous School Details */}

                {/* Documents Section */}
                <div className="col-xxl-12">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h5>Documents</h5>
                      {studentStatus === "active" && (
                        <Link
                          to={`${routes.studentDocuments.replace(
                            ":id",
                            id || ""
                          )}`}
                          className="btn btn-primary btn-sm"
                        >
                          <i className="ti ti-plus me-1"></i>Upload Documents
                        </Link>
                      )}
                    </div>
                    <div className="card-body">
                      <div className="row g-3">
                        {/* Birth Certificate */}
                        <div className="col-sm-6 col-md-4 col-xl-3">
                          <div className="card border shadow-none h-100">
                            <div className="card-body d-flex flex-column">
                              <div className="document-download">
                                <i className="ti ti-file-certificate fs-1 text-primary"></i>
                              </div>
                              <div className="mt-3">
                                <h6 className="mb-1">Birth Certificate</h6>
                                <p className="fs-13 text-muted mb-2">
                                  {student?.docs?.dob
                                    ? "Uploaded"
                                    : "Not uploaded"}
                                </p>
                                {student?.docs?.dob && (
                                  <a
                                    href={`${API_CONFIG.BASE_URL}students/download-dob/${student.docs.dob}`}
                                    className="text-primary d-flex align-items-center"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <i className="ti ti-download me-1"></i>
                                    Download
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Documents Section */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals />
    </>
  );
};

export default StudentDetails;
